type ErrorPageType = "404" | "error" | "offline";

interface ErrorPageProps {
  type?: ErrorPageType;
  message?: string;
}

const defaults: Record<ErrorPageType, { title: string; subtitle: string }> = {
  "404": {
    title: "404",
    subtitle: "This page does not exist.",
  },
  error: {
    title: "Something went wrong",
    subtitle: "An unexpected error occurred.",
  },
  offline: {
    title: "No connection",
    subtitle: "Check your internet and try again.",
  },
};

export function ErrorPage({ type = "404", message }: ErrorPageProps): React.ReactNode {
  const info = defaults[type];

  return (
    <div
      data-testid="error-page"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#000510",
        color: "#00ddff",
        fontFamily: "'Orbitron', system-ui, sans-serif",
        textAlign: "center",
        padding: 24,
      }}
    >
      <h1 style={{ fontSize: 72, margin: 0, letterSpacing: 8, color: "#4488ff" }}>
        {info.title}
      </h1>
      <p style={{ fontSize: 16, margin: "16px 0 8px", color: "rgba(255,255,255,0.6)" }}>
        {info.subtitle}
      </p>
      {message && (
        <p style={{ fontSize: 12, margin: "8px 0 24px", color: "rgba(255,255,255,0.35)" }}>
          {message}
        </p>
      )}
      <a
        href="/"
        style={{
          color: "#00ddff",
          fontSize: 14,
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        Return home
      </a>
    </div>
  );
}
